import { v4 as uuidv4 } from "uuid";
import { NormalizeParkRedemption } from "./albumContractAdapter";

/**
 * Builds album experiences and applies the initial park-unlock state.
 *
 * @param {Array<Object>} experiences Public album experiences.
 * @param {Array<number>} selectedParks Selected park identifiers.
 * @returns {Array<Object>} Normalized album experiences.
 */
function BuildAlbumExperiences(experiences, selectedParks) {
    return (Array.isArray(experiences) ? experiences : []).map(
        (experience) => {
            const parkId = Number(experience?.Park?.Id);

            const baseUnlocked = Boolean(experience?.Unlocked);

            return {
                ...experience,
                BaseUnlocked: baseUnlocked,
                Unlocked:
                    baseUnlocked ||
                    selectedParks.includes(parkId),
            };
        }
    );
}

/**
 * Builds a normalized download-code album from the GetAlbums response.
 *
 * @param {Object} data GetAlbums collection.
 * @returns {Object} Album ready for Vuex storage.
 */
export function BuildAlbumFromApiResponse(data) {
    const photoDetails = data?.PhotoDetails || {};
    const order = Number(photoDetails.Order);
    const isPostSaleOrder = Number.isFinite(order) && order > 0;
    const parkRedemption = isPostSaleOrder
        ? null
        : NormalizeParkRedemption(
            photoDetails.ParkRedemption
        );
    const selectedParks = parkRedemption?.SelectedParks || [];
    const park = BuildAlbumExperiences(
        data?.PhotoExperiences,
        selectedParks
    );

    return {
        uuid: uuidv4(),
        code: photoDetails.JoinedCode,
        ExpiresDate: park[0]?.ExpiresDate ?? null,
        park,

        // Existing invoice/folio used to relate an additional individual sale.
        // The generated download code remains the one returned by the new sale.
        invoiceId: photoDetails.InvoiceId ?? null,

        // 0 / null / undefined = regular order; 1 or 3 = post-sale order.
        order: photoDetails.Order,
        Type: photoDetails.Type,
        getCode: {
            PackageName:
                photoDetails.Service?.Id ??
                photoDetails.ServiceId ??
                null,
        },
        parkRedemption,
    };
}
